import { z } from "zod";
import { DmaCalculationState } from "../dma-calculation-state";
import { dmaCalculationFailureDtoSchema } from "./dma-calculation-failure.schema";
import { dmaCalculationResultsDtoSchema } from "./dma-calculation-results.schema";
export const dmaFailedCalculationStatusDtoSchema = z.object({
    state: z.literal(DmaCalculationState.Failed),
    jobStartedAt: z.string().datetime({ offset: true }),
    jobFinishedAt: z.string().datetime({ offset: true }),
    errors: z.array(dmaCalculationFailureDtoSchema),
    partialResults: dmaCalculationResultsDtoSchema,
});
